import { EnvironmentTypes } from '../constants/environmentTypes';

export const isStage = () => {
  return process.env.REACT_APP_ENV === EnvironmentTypes.Development;
};